import { CircularProgress, Stack } from "@mui/material";

function Spinner(props: any) {
  const { size } = props;
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="center"
      sx={{ height: "100vh" }}
    >
      <CircularProgress color="warning" size={size || 46} />
    </Stack>
  );
}

export default Spinner;
